import ListingsConfig from 'vcomponents/listing/config';
import RoutingResolver from 'routingResolver';

const ConfigListings = new ListingsConfig()

class ListingResolver extends RoutingResolver{

    buildFiltersFromQuery(to) {
        let urlParams = new URLSearchParams(decodeURI(window.location.search)).get('filter')

        if (urlParams != '') {
            to.params['filter'] = JSON.parse(urlParams)
        }
    }

    feed(to) {
        if (this.key != '') {
            let params = ConfigListings.getListing(this.key)
            this.buildFiltersFromQuery(to)
            if (params && Object.keys(params).length > 0) {
                Object.keys(params).forEach(param => {
                    if (!to.params[param]) {
                        to.params[param] = params[param]
                    }
                })
            }
        }
    }
}

export default ListingResolver
